import { GATEWAY_OFFLINE_THRESHOLD_SEC, GATEWAY_STATUS } from '../constants/gateway';

/** Parse router ISO heartbeat (e.g. 2026-07-07T11:43:12+0530) */
export const parseHeartbeatIso = (isoString) => {
  if (!isoString || typeof isoString !== 'string') return null;
  const normalized = isoString.replace(/([+-]\d{2})(\d{2})$/, '$1:$2');
  const ms = Date.parse(normalized);
  return Number.isNaN(ms) ? null : ms;
};

export const computeGatewayStatus = (lastHeartbeatIso, nowMs = Date.now()) => {
  const heartbeatMs = parseHeartbeatIso(lastHeartbeatIso);
  if (heartbeatMs == null) return { status: GATEWAY_STATUS.UNKNOWN, secondsSinceHeartbeat: null };
  const secondsSinceHeartbeat = Math.max(0, Math.floor((nowMs - heartbeatMs) / 1000));
  const status =
    secondsSinceHeartbeat > GATEWAY_OFFLINE_THRESHOLD_SEC
      ? GATEWAY_STATUS.OFFLINE
      : GATEWAY_STATUS.ONLINE;
  return { status, secondsSinceHeartbeat };
};

export const formatHeartbeatAge = (seconds) => {
  if (seconds == null || Number.isNaN(seconds)) return '—';
  if (seconds < 60) return `${seconds} sec ago`;
  if (seconds < 3600) return `${Math.floor(seconds / 60)} min ago`;
  const hours = Math.floor(seconds / 3600);
  return hours === 1 ? '1 hr ago' : `${hours} hr ago`;
};
